module.exports = __webpack_public_path__ + "img/micronesia.5f418bd7.svg";